module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.8fc9b23c.eot";